// extracted by mini-css-extract-plugin
export default {"modal":"AddVipModal_modal__536f4","closeBtnContainer":"AddVipModal_closeBtnContainer__NcPAF"};